import { DEFAULT_SITE } from './siteDefaults';

/** Marquee brand names from API; falls back to defaults when missing or empty. */
export function resolveBrandTicker(site) {
  const d = DEFAULT_SITE.brandTicker;
  const raw = site?.brandTicker;
  if (!Array.isArray(raw) || raw.length === 0) {
    return [...d];
  }
  const out = raw
    .map((s) => (typeof s === 'string' ? s.trim() : ''))
    .filter(Boolean);
  return out.length ? out : [...d];
}
